import type { SVGProps } from "react";

export type FooterGlyph = (props: SVGProps<SVGSVGElement>) => JSX.Element;

const HomeGlyph: FooterGlyph = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.85 4.85 10.3a1.55 1.55 0 0 0-.6 1.23v6.17A2.05 2.05 0 0 0 6.3 19.75h11.4a2.05 2.05 0 0 0 2.05-2.05v-6.17c0-.48-.22-.93-.6-1.23zm-1.72 14.9v-4.42c0-.62.5-1.12 1.12-1.12h1.2c.62 0 1.12.5 1.12 1.12v4.42z"
      fill="currentColor"
    />
  </svg>
);

const TimerGlyph: FooterGlyph = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M9.05 3.7h5.9a1.02 1.02 0 0 1 0 2.04h-5.9a1.02 1.02 0 0 1 0-2.04Z"
      fill="currentColor"
    />
    <path
      d="m17.4 6.35.82-.82a.98.98 0 0 1 1.39 1.38l-.82.83a.98.98 0 0 1-1.39-1.39Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20.5a7.15 7.15 0 1 0 0-14.3 7.15 7.15 0 0 0 0 14.3Zm0-2.15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
      fill="currentColor"
    />
    <path
      d="M12 10.2v3.25l2.35 1.35"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.9"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

const WorkoutsGlyph: FooterGlyph = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <rect
      x="3.65"
      y="9.65"
      width="2.15"
      height="4.7"
      rx="1.08"
      fill="currentColor"
    />
    <rect
      x="6.55"
      y="8.2"
      width="2.35"
      height="7.6"
      rx="1.15"
      fill="currentColor"
    />
    <rect
      x="9.65"
      y="10.9"
      width="4.7"
      height="2.2"
      rx="1.1"
      fill="currentColor"
    />
    <rect
      x="15.1"
      y="8.2"
      width="2.35"
      height="7.6"
      rx="1.15"
      fill="currentColor"
    />
    <rect
      x="18.2"
      y="9.65"
      width="2.15"
      height="4.7"
      rx="1.08"
      fill="currentColor"
    />
  </svg>
);

export const footerGlyphs = {
  home: HomeGlyph,
  timer: TimerGlyph,
  workouts: WorkoutsGlyph,
};
